<template>
	<div>
		<div class="d-flex flex-column align-items-center ">
			<div class="appointment-main" style="width: 100%;">
				<div class="d-flex flex-wrap alcenter justify-content-between" :class="!isShow ? 'mt-4' : ''">
					<div class="flex alcenter">
						<div class="border-gray br4 flex alcenter justify-content-center" @click="prevWeek"
							:style="isShow ? 'width: 42px;height: 26px;' : 'width: 50px;height: 30px;'">
							<a-icon type="left" style="color: #52C4C9;font-size: 14px;"></a-icon>
						</div>
						<div class="border-gray br4 flex alcenter justify-content-center" @click="nextWeek"
							:style="isShow ? 'width: 42px;height: 26px;' : 'width: 50px;height: 30px;'">
							<a-icon type="right" style="color: #52C4C9;font-size: 14px;"></a-icon>
						</div>
						<div class="cl-info ml10" :class="fontSize">
							{{ weekStart }} - {{ weekEnd }}
						</div>
					</div>
					<div class="cl-info" :class="fontSize">
						{{ $t('classTime.selectCourseStartTime', { timeZone: timeZone }) }}
					</div>
				</div>
				<div class="d-flex flex-row border-b mt-3">
					<div v-for="(day, index) in weekDays" :key="index" class="flex-grow-1 text-center px-1"
						:class="fontSize">
						
						<div class="border-t-theme">{{ formatDay(day.date) }}</div>
						<div class=" cl-info">{{ formatWeekday(day.date) }}</div>
						<ul class="list-unstyled cl-black mt-2">
							<li v-if="day.courseTimes && day.courseTimes.length > 0">
								<!-- <div class="clickAct cl-theme" v-for="(item, index) in day.courseTimes"
									style="border: 1px solid #fff;"
									@mouseenter="showPopup($event, day.date, item)"
									@mouseleave="hidePopup"
									@click="!isShow ? togglePopup($event, day.date, item) : ''"
									:class="{
										'selected': isSelected(day.date, item),
										'selectedBorder': isBorder(day.date, item),
										'cl-info': isTimeBeforeCurrentTime(item.start, day.date)
									}">
									{{ formatTimeForDisplay(item.start, day.date) }}
								</div> -->
								<div class="clickAct cl-theme" 
								     v-for="(item, index) in day.courseTimes"
								     style="border: 1px solid #fff;"
								     @mouseenter="showPopup($event, day.date, item)"
								     @mouseleave="hidePopup"
								     @click="!isShow ? togglePopup($event, day.date, item) : ''"
								     :class="{
								       'selected': isSelected(day.date, item),
								       'selectedBorder': isBorder(day.date, item),
								       'cl-info': isTimeBeforeCurrentTime(item.start, day.date) || isTimeBlocked(day.date, item),
								       'disabled': isTimeBlocked(day.date, item) && !isSelected(day.date, item)
								     }"
								     :style="{
								       cursor: (isTimeBeforeCurrentTime(item.start, day.date) || isTimeBlocked(day.date, item)) ? 'not-allowed' : 'pointer'
								     }">
								  {{ formatTimeForDisplay(item.start, day.date) }}
								</div>
							</li>
							<li v-else>{{ $t('classTime.noCourse') }}</li>
						</ul>
					</div>
				</div>
				<div v-if="isPopupVisible" class="popup" :style="{ top: popupTop + 'px', left: popupLeft + 'px' }">
					<div class="cl-info">{{ $t('classTime.obtained') }}</div>
					<div>{{ selectedDate }}</div>
					<div>{{ formatTimeForDisplay(selectedTime.start, selectedDate) }} - {{ formatTimeForDisplay(selectedTime.end, selectedDate) }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		isShow: {
			type: Boolean,
			default: false
		},
		fontSize: {
			type: String,
			default: '1rem'
		},
		classTime: {
			type: Array,
			default: () => []
		},
		maxNum: {
			type: Number,
			default: 0
		},
		is_experience: {
			type: String,
			default: '2'
		}
	},
	data() {
		return {
			currentDate: new Date(),
			weekStart: '',
			weekEnd: '',
			weekDays: [],
			isPopupVisible: false,
			selectedDate: '',
			selectedTime: '',
			popupTop: 0,
			popupLeft: 0,
			selectedTimes: [],
			classTimeList: [],
			timeZone: localStorage.getItem('timeZone') || 'UTC',
			
			
			 blockedTimes: [], // 存储因选中而被阻塞的时间段
			courseDuration: 50, // 课程时长50分钟
		};
	},
	watch: {
		classTime(newValue) {
			this.classTimeList = this.convertScheduleToArray(newValue);
		}
	},
	mounted() {
		this.classTimeList = this.convertScheduleToArray(this.classTime);
		console.log("-------this.classTime",this.classTime);
		this.calculateWeek();
		this.fetchCourseTimes();
	},
	methods: {
		convertScheduleToArray(arr) {
			const result = Array.from({ length: 7 }, () => []);
			const dayMap = {
				'monday_switch': 0,
				'tuesday_switch': 1,
				'wednesday_switch': 2,
				'thursday_switch': 3,
				'friday_switch': 4,
				'saturday_switch': 5,
				'sunday_switch': 6
			};

			arr.forEach(item => {
				const [minHour, minMinute] = item.min_time.split(':').map(Number);
				const [maxHour, maxMinute] = item.max_time.split(':').map(Number);

				let currentTime = new Date();
				currentTime.setHours(minHour, minMinute, 0, 0);
				const endTime = new Date();
				endTime.setHours(maxHour, maxMinute, 0, 0);

				while (currentTime < endTime) {
					const startTime = currentTime.toLocaleTimeString('en-US', {
						hour: '2-digit',
						minute: '2-digit',
						hour12: false
					});

					this.is_experience === '2'
						? currentTime.setMinutes(currentTime.getMinutes() + 50)
						: currentTime.setMinutes(currentTime.getMinutes() + 25);

					const endTimeStr = currentTime.toLocaleTimeString('en-US', {
						hour: '2-digit',
						minute: '2-digit',
						hour12: false
					});

					for (const [switchKey, dayIndex] of Object.entries(dayMap)) {
						if (item[switchKey] === 1) {
							result[dayIndex].push({ start: startTime, end: endTimeStr });
						}
					}

					this.is_experience === '2'
						? currentTime.setMinutes(currentTime.getMinutes() - 20)
						: currentTime.setMinutes(currentTime.getMinutes() + 5);
				}
			});
			return result;
		},
		isTimeBeforeCurrentTime(timeStr, date) {
			const [hour, minute] = timeStr.split(':');
			const now = new Date();
			const specificTime = new Date();
			specificTime.setHours(hour, minute, 0, 0);

			if (date < this.getTodayDate()) {
				return true;
			} else if (date === this.getTodayDate()) {
				return now > specificTime;
			} else {
				return false;
			}
		},
		getTodayDate() {
			const now = new Date();
			return this.formatDate(now);
		},
		formatTimeForDisplay(localTime, dateStr) {
			const [hour, minute] = localTime.split(':').map(Number);
			const baseDate = new Date(`${dateStr}T${localTime}:00`);
			const options = {
				hour: '2-digit',
				minute: '2-digit',
				hour12: false,
				// timeZone: this.timeZone || 'UTC' //时区转换
			};
			return new Intl.DateTimeFormat('en-GB', options).format(baseDate);
		},
		formatWeekday(dateStr) {
			const date = new Date(dateStr);
			const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
			return weekdays[date.getDay()];
		},
		formatDay(dateStr) {
			const date = new Date(dateStr);
			return `${date.getDate()}`;
		},
		formatDayAndWeekday(dateStr) {
			const date = new Date(dateStr);
			const day = date.getDate();
			const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
			const weekday = weekdays[date.getDay()];
			return `${day}日 ${weekday}`;
		},
		calculateWeek() {
			const current = new Date(this.currentDate);
			const dayOfWeek = current.getDay();
			const startOffset = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
			const start = new Date(current.setDate(current.getDate() - startOffset));
			const end = new Date(start);
			end.setDate(end.getDate() + 6);

			this.weekStart = this.formatDate(start);
			this.weekEnd = this.formatDate(end);

			this.weekDays = [];
			for (let i = 0; i < 7; i++) {
				const day = new Date(start);
				day.setDate(day.getDate() + i);
				this.weekDays.push({
					date: this.formatDate(day),
					courseTimes: []
				});
			}
		},
		formatDate(date) {
			return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
		},
		prevWeek() {
			this.currentDate.setDate(this.currentDate.getDate() - 7);
			this.calculateWeek();
			this.fetchCourseTimes();
		},
		nextWeek() {
			this.currentDate.setDate(this.currentDate.getDate() + 7);
			this.calculateWeek();
			this.fetchCourseTimes();
		},
		fetchCourseTimes() {
			this.weekDays.forEach((day, index) => {
				day.courseTimes = this.classTimeList[index];
			});
		},
		// togglePopup(event, date, time) {
		// 	if (this.isTimeBeforeCurrentTime(time.start, date)) return;
		// 	const index = this.selectedTimes.findIndex(item => item.date === date && item.time === time);
		// 	if (index > -1) {
		// 		this.selectedTimes.splice(index, 1);
		// 	} else {
		// 		if (this.selectedTimes.length >= this.maxNum) return;
		// 		this.selectedTimes.push({ date, time });
		// 	}
		// 	this.$emit('select', this.selectedTimes);
		// },
		togglePopup(event, date, time) {
		  if (this.isTimeBeforeCurrentTime(time.start, date)) return;
		  
		  const index = this.selectedTimes.findIndex(item => item.date === date && item.time === time);
		  
		  if (index > -1) {
		    // 取消选中：移除当前时间段并解除相关的阻塞
		    this.selectedTimes.splice(index, 1);
		    this.unblockAdjacentTimes(date, time);
		  } else {
		    // 选中新时间段：检查是否在阻塞时间段内
		    if (this.isTimeBlocked(date, time)) return;
		    if (this.selectedTimes.length >= this.maxNum) return;
		    
		    this.selectedTimes.push({ date, time });
		    this.blockAdjacentTimes(date, time);
		  }
		  this.$emit('select', this.selectedTimes);
		},
		// 阻塞相邻时间段
		blockAdjacentTimes(date, time) {
		  const blocked = [];
		  const selectedStartTime = this.parseTimeString(time.start);
		  const selectedEndTime = this.parseTimeString(time.end);
		  
		  // 找到当前日期所有的课程时间段
		  const dayIndex = this.weekDays.findIndex(day => day.date === date);
		  if (dayIndex === -1) return;
		  
		  const dayCourseTimes = this.weekDays[dayIndex].courseTimes;
		  
		  dayCourseTimes.forEach(courseTime => {
		    const courseStart = this.parseTimeString(courseTime.start);
		    const courseEnd = this.parseTimeString(courseTime.end);
		    
		    // 如果课程时间段与选中的50分钟课程有重叠，则阻塞
		    if (this.isTimeOverlap(selectedStartTime, selectedEndTime, courseStart, courseEnd)) {
		      blocked.push({
		        date: date,
		        time: courseTime
		      });
		    }
		  });
		  
		  this.blockedTimes = [...this.blockedTimes, ...blocked];
		},
		
		// 解除相邻时间段的阻塞
		unblockAdjacentTimes(date, time) {
		  const selectedStartTime = this.parseTimeString(time.start);
		  const selectedEndTime = this.parseTimeString(time.end);
		  
		  this.blockedTimes = this.blockedTimes.filter(blocked => {
		    const blockedStart = this.parseTimeString(blocked.time.start);
		    const blockedEnd = this.parseTimeString(blocked.time.end);
		    
		    // 如果阻塞的时间段与当前取消的时间段有重叠，则解除阻塞
		    // 但要检查是否还被其他选中的时间段阻塞
		    if (this.isTimeOverlap(selectedStartTime, selectedEndTime, blockedStart, blockedEnd)) {
		      // 检查这个时间段是否还被其他选中的时间段阻塞
		      return this.isStillBlockedByOthers(blocked.date, blocked.time, date, time);
		    }
		    return true;
		  });
		},
		
		// 检查时间段是否仍然被其他选中的时间段阻塞
		isStillBlockedByOthers(checkDate, checkTime, excludeDate, excludeTime) {
		  const checkStart = this.parseTimeString(checkTime.start);
		  const checkEnd = this.parseTimeString(checkTime.end);
		  
		  return this.selectedTimes.some(selected => {
		    if (selected.date === excludeDate && selected.time === excludeTime) {
		      return false; // 排除当前取消选中的时间段
		    }
		    
		    const selectedStart = this.parseTimeString(selected.time.start);
		    const selectedEnd = this.parseTimeString(selected.time.end);
		    
		    return this.isTimeOverlap(selectedStart, selectedEnd, checkStart, checkEnd);
		  });
		},
		
		// 解析时间字符串为分钟数
		parseTimeString(timeStr) {
		  const [hours, minutes] = timeStr.split(':').map(Number);
		  return hours * 60 + minutes;
		},
		
		// 检查两个时间段是否有重叠
		isTimeOverlap(start1, end1, start2, end2) {
		  return start1 < end2 && end1 > start2;
		},
		
		// 检查时间段是否被阻塞
		isTimeBlocked(date, time) {
		  return this.blockedTimes.some(blocked => 
		    blocked.date === date && 
		    blocked.time.start === time.start && 
		    blocked.time.end === time.end
		  );
		},
		
		
		
		
		showPopup(event, date, time) {
			this.selectedDate = date;
			this.selectedTime = time;
			this.isPopupVisible = true;
			const rect = event.target.getBoundingClientRect();
			this.popupTop = rect.bottom + window.pageYOffset;
			this.popupLeft = rect.left + window.pageXOffset;
		},
		hidePopup() {
			this.isPopupVisible = false;
		},
		isSelected(date, time) {
			return this.selectedTimes.some(item => item.date === date && item.time === time);
		},
		isBorder(date, time) {
			let boo = this.selectedTimes.some(item => item.date === date && item.time === time);
			return (
				boo &&
				this.selectedTimes[this.selectedTimes.length - 1].time === time &&
				this.selectedTimes[this.selectedTimes.length - 1].date === date &&
				this.isPopupVisible
			);
		}
	}
};
</script>

<style scoped>
.popup {
	position: absolute;
	background-color: white;
	padding: 10px 20px;
	border: 1px solid #ccc;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	z-index: 1000;
}

.list-unstyled {
	list-style: none;
	padding-left: 0;
}

.selected {
	color: red;
	border-radius: 4px;
}

.selectedBorder {
	border: 1px solid red !important;
}
.disabled {
  opacity: 0.5;
  pointer-events: none;
  color: #ccc !important;
}

.clickAct {
  transition: all 0.3s ease;
}

.clickAct:not(.disabled):hover {
  background-color: #f0f0f0;
}
</style>
